import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { api } from '@/api';
import { DEFAULT_DATE_FORMAT, EMPTY_FIELD_VALUE, RAW_DATE_FORMAT } from '@/common/constants';
import { API_URL } from '@/dtos';

interface Response {
  date_from?: string;
  date_to?: string;

  percent_passed: number;
}
const QUERY_KEY = 'CIP_STATUS_BRIEF_QUERY';
const useCIPStatusBriefQuery = () => {
  // TODO: missing type
  const { data, isLoading } = useQuery(
    [QUERY_KEY],
    () => api.get<Response>(API_URL.REPORTS_CIP_STATUS_REPORT_BRIEF),
    {
      cacheTime: 0,
    }
  );

  const title = useMemo(() => {
    const response = data?.data;
    const fromDate = response?.date_from;
    const toDate = response?.date_to;

    if (!fromDate && !toDate) {
      return null;
    }
    const formattedFromDate = fromDate ? dayjs(fromDate, RAW_DATE_FORMAT).format(DEFAULT_DATE_FORMAT) : '';

    const formattedToDate = toDate ? dayjs(toDate, RAW_DATE_FORMAT).format(DEFAULT_DATE_FORMAT) : '';
    return `${formattedFromDate || EMPTY_FIELD_VALUE} - ${formattedToDate || EMPTY_FIELD_VALUE}`;
  }, [data?.data]);
  const formattedData = useMemo(() => {
    const response = data?.data;
    const percents = response?.percent_passed;
    return percents ? percents : null;
  }, [data?.data]);
  return {
    isLoading,
    title,
    data: formattedData,
  };
};

export default useCIPStatusBriefQuery;
